import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface LogoProps {
  variant?: 'default' | 'small';
  isFooter?: boolean;
}

const Logo: React.FC<LogoProps> = ({ variant = 'default', isFooter = false }) => {
  const location = useLocation();
  const baseClasses = "transition-opacity hover:opacity-80 relative z-0";
  const sizeClasses = variant === 'small' || window.innerWidth < 768
    ? 'h-16 md:h-32 w-32 md:w-64'
    : 'h-20 md:h-40 w-40 md:w-80';

  const to = isFooter && location.pathname === '/' ? '/#top' : '/';

  return (
    <Link 
      to={to}
      className={`${baseClasses} ${sizeClasses} block`}
      onClick={(e) => {
        if (isFooter && location.pathname === '/') {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }}
    >
      <img
        src={`${import.meta.env.BASE_URL}logo-blue.png`}
        alt="Expert Maintenance Solutions"
        className="h-full w-full object-contain"
        style={{ maxWidth: '100%', maxHeight: '100%' }}
        loading={variant === 'small' ? 'lazy' : 'eager'}
        width={variant === 'small' ? 128 : 160}
        height={variant === 'small' ? 64 : 80}
      />
    </Link>
  );
};

export default Logo;